import { render } from "./SpinnStudioLanguages.vue?vue&type=template&id=155f647a"
import script from "./SpinnStudioLanguages.vue?vue&type=script&lang=js"
export * from "./SpinnStudioLanguages.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__